import React from 'react';
import { useQuery } from '@apollo/client';
import { QUERY_NIVEAU_FILIERE } from '../../../../../graphql/query/challenge/queryChallengeNivFil';
import { LoadingLayout } from 'components/molecules/Loaders/LoadingLayout';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { CreateClasseState } from '../../../../../store/reducers/createClasse.reducer';
import FormCreateClasseView from './FormCreateClasse.view';
import { GetNiveauAndFilliereQuery } from '../../../../../graphql/generated/graphql';

export interface FormCreateClasseTypes {
  classe: CreateClasseState;
  handleChange: (e: { target: { value: string; name: string } }) => void;
}

const FormCreateClasse = ({ handleChange, classe }: FormCreateClasseTypes) => {
  const { data, loading, error } = useQuery<GetNiveauAndFilliereQuery>(
    QUERY_NIVEAU_FILIERE
  );
  if (loading) return <LoadingLayout variant="centeredOnly" />;
  if (error)
    return (
      <ErrorContainer
        text={
          'Erreur dans la récupération des niveaux et filières existantes... '
        }
      />
    );

  const fillieres = data?.fillieres?.data?.map(filliere => ({
    id: filliere.id,
    name: filliere.attributes?.name
  }));

  const niveaus = data?.niveaux?.data?.map(niveau => ({
    id: niveau.id,
    name: niveau.attributes.name
  }));

  return (
    <FormCreateClasseView
      handleChange={handleChange}
      classe={classe}
      fillieres={fillieres}
      niveaus={niveaus}
    />
  );
};

export default FormCreateClasse;
